import React from 'react';
import { useTranslation } from 'react-i18next';
import { Select } from 'antd';
import { useSessionAction } from '@hooks/useSessionAction';
import { SessionFormItem } from '../../Components/SessionFormItem';
import { ApptActionCodes } from 'vl-common/src/schemas/getMetaAppointments';
import { useSessionAppointment } from '@hooks/useSessionAppointment';

const SUBTYPE_LABELS: Record<ApptActionCodes, string | undefined> = {
  BKVCON: 'Who are you referring to?',
  REFF2F: 'Who are you referring to?',
  DISCHG: 'Discharge type',
  PRESCR: undefined,
  INVREQ: undefined,
  REF2AE: undefined,
  TRCARE: undefined,
  PTFACT: undefined
};

const REFERRAL_ACTIONS: ApptActionCodes[] = ['BKVCON', 'REFF2F'];

const ActionSubtypeFormItem = ({
  actionCode,
  onChange
}: {
  actionCode: ApptActionCodes;
  onChange: (value: string) => void;
}) => {
  const { t } = useTranslation('common');
  const { meta, SUBTYPE_KEY } = useSessionAction(actionCode);
  const {
    appointment: { appointment_completed: isCompleted, read_only: readonly }
  } = useSessionAppointment();

  const isReferral = REFERRAL_ACTIONS.includes(actionCode);

  return (
    <SessionFormItem name={SUBTYPE_KEY} label={SUBTYPE_LABELS[actionCode] || 'Action subtype'} required>
      <Select
        placeholder={t('Select from dropdown')}
        disabled={isCompleted || readonly}
        onSelect={onChange}
        data-testid={isReferral ? 'clinician-type-select' : 'action-subtype-select'}
        options={meta?.action_subtypes?.map((subtype) => ({
          label: subtype.action_subtype_desc,
          value: subtype.action_subtype_code
        }))}
      />
    </SessionFormItem>
  );
};

export default ActionSubtypeFormItem;
